import React from 'react'
import { useCookies } from 'react-cookie'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import { Button } from '../../../components/Button/Button'
import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'

import styles from './BoxDocumentIntelligenceUpsellBanner.module.scss'

const _COOKIE_NAME = 'hideBoxDocIntelUpsell'
const _COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export const BoxDocumentIntelligenceUpsellBanner: React.FC = () => {
  const [cookies, setCookie] = useCookies()
  const navigate = useNavigate()

  const handleHideBanner = () => setCookie(_COOKIE_NAME, true, { path: '/', maxAge: _COOKIE_MAX_AGE })

  if (cookies[_COOKIE_NAME]) {
    return null
  }

  return (
    <div className={classNames('d-flex gap-4 p-4 border zocks-border-color-primary-light', styles.banner)}>
      <div className='d-flex flex-column flex-1 gap-2'>
        <span className='paragraph-large bold zocks-text-gray-900'>Upload documents from Box to get instant insights</span>
        <span className='paragraph-small zocks-text-gray-900'>
          Select documents directly from Box. Your AI Assistant extracts key client updates — financial changes, life events, and more. Review the insights and
          sync them to your CRM in one click.
        </span>
      </div>
      <div className='d-flex flex-column align-items-end justify-content-between flex-shrink-0'>
        <i className={classNames('bi bi-x cursor-pointer', styles.close)} onClick={handleHideBanner} />
        <div className='d-flex gap-2'>
          <Button variant='header' className='button-small' onClick={() => navigate(`/account/plan/free-trial/${DELTA_TRIAL_FEATURES['processDocument'].id}`)}>
            Start free trial
          </Button>
          <Button variant='primary' className='button-small' onClick={() => navigate('/account/plan')}>
            Upgrade to Ultimate
          </Button>
        </div>
      </div>
    </div>
  )
}
